if (!customElements.get('custom-select')) {
  customElements.define(
    'custom-select',
    class CustomSelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        if (!this.select) return;

        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.className = 'custom-select__button select__select';
        this.button.setAttribute('aria-haspopup', 'listbox');
        this.button.setAttribute('aria-expanded', 'false');

        this.labelSpan = document.createElement('span');
        this.labelSpan.className = 'custom-select__label';
        this.button.appendChild(this.labelSpan);

        this.list = document.createElement('ul');
        this.list.className = 'custom-select__list';
        this.list.setAttribute('role', 'listbox');

        this.renderOptions();
        this.updateLabel();

        this.select.setAttribute('hidden', 'hidden');
        this.select.insertAdjacentElement('afterend', this.list);
        this.select.insertAdjacentElement('afterend', this.button);

        this.button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggle();
        });
        this.button.addEventListener('keydown', this.onButtonKeydown.bind(this));
        this.list.addEventListener('keydown', this.onListKeydown.bind(this));

        this._onDocClick = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        document.addEventListener('click', this._onDocClick);
      }

      disconnectedCallback() {
        if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
      }

      renderOptions() {
        this.list.innerHTML = '';
        this.optionEls = Array.from(this.select.options).map((opt, index) => {
          const li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.className = 'custom-select__option';
          li.textContent = opt.textContent.trim();
          li.dataset.value = opt.value;
          li.tabIndex = -1;
          if (opt.selected) {
            li.setAttribute('aria-selected', 'true');
            li.classList.add('selected');
          } else {
            li.setAttribute('aria-selected', 'false');
          }
          li.addEventListener('click', () => this.selectOption(opt));
          this.list.appendChild(li);
          return li;
        });
      }

      selectOption(opt) {
        if (this.select.value !== opt.value) {
          this.select.value = opt.value;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.updateLabel();
        this.close();
        this.button.focus();
      }

      updateLabel() {
        const selected = this.select.options[this.select.selectedIndex];
        this.labelSpan.textContent = selected ? selected.textContent.trim() : '';
        if (this.optionEls) {
          this.optionEls.forEach((li, i) => {
            const isSelected = this.select.options[i] === selected;
            li.classList.toggle('selected', isSelected);
            li.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          });
        }
      }

      toggle() {
        this.open ? this.close() : this.openList();
      }

      openList() {
        this.open = true;
        this.list.classList.add('open');
        this.button.setAttribute('aria-expanded', 'true');
        const visible = (this.optionEls || []).filter((li) => li.style.display !== 'none');
        const current = visible.find((li) => li.classList.contains('selected')) || visible[0];
        current?.focus();
      }

      close() {
        this.open = false;
        this.list.classList.remove('open');
        this.button.setAttribute('aria-expanded', 'false');
      }

      onButtonKeydown(event) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.openList();
        }
      }

      onListKeydown(event) {
        const items = (this.optionEls || []).filter((li) => li.style.display !== 'none');
        const idx = items.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          (items[idx + 1] || items[0])?.focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          (items[idx - 1] || items[items.length - 1])?.focus();
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          document.activeElement?.click();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          this.button.focus();
        } else if (event.key === 'Tab') {
          this.close();
        }
      }
    }
  );
}
